import React from 'react';

import { UiText } from '@shared/ui';

import cls from './EmployeePhone.module.css';
import { IEmployee } from '../../../../model/types';

interface IEmployeePhoneProps {
    phone: IEmployee['phone'];
}

export const EmployeePhone = ({ phone }: IEmployeePhoneProps) => (
    <UiText tag="span" classes={cls.colorTertiary} variant="caption" align="center">
        {phone}
    </UiText>
);
